import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostcodesComponent } from './postcodes.component';
import { PostcodesService } from './services/postcodes.service';
import { DataTableModule } from 'primeng/components/datatable/datatable';
import { PostcodesDetailComponent } from './postcodes-detail/postcodes-detail.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OpenPostcodesComponent } from './open-postcodes/open-postcodes.component';
import { PostcodesRoutingModule } from './postcodes-routing.module';
import { OpenPostcodesResolver } from './resolvers/open-postcodes.resolver';

@NgModule({
	imports: [
		CommonModule,
		DataTableModule,
		FormsModule,
		ReactiveFormsModule
	],
	exports: [
		PostcodesComponent,
		PostcodesRoutingModule
	],
	providers: [
		PostcodesService,
		OpenPostcodesResolver
	],
	declarations: [
		PostcodesComponent,
		PostcodesDetailComponent,
		OpenPostcodesComponent
	]
})
export class PostcodesModule
{
}



// WEBPACK FOOTER //
// ./src/app/postcodes/postcodes.module.ts